// PwaUpdateBanner.tsx — Surfaces service-worker updates to the user.
//
// CV-195: when a new SW is waiting, show a small banner inviting reload.
// vite-plugin-pwa is configured with skipWaiting + clientsClaim + autoUpdate,
// so the SW activates without intervention — but the page still holds the
// old chunks until the user reloads. The banner makes that explicit.

import { useRegisterSW } from 'virtual:pwa-register/react';

export default function PwaUpdateBanner() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh) return null;

  return (
    <div role="alert" className="pwa-update-banner">
      <span>A new version of ConstructiVision Web is available.</span>
      <button type="button" onClick={() => updateServiceWorker(true)}>Reload</button>
      <button type="button" onClick={() => setNeedRefresh(false)} aria-label="Dismiss update">×</button>
    </div>
  );
}
